<template>
  <tr style="cursor: pointer;" :style="{'background-color': notification.read ? '#fff' : '#f8f9fa'}">
    <td style="width: 2%;">
      <div class="d-flex align-items-center">
        <i
          class="las font-20 mr-2"
          :class="icon"
        />
      </div>
    </td>
    <td class="description">
      <h6>{{ notification.libelle }}</h6>
      <div class="row">
          <div class="col-12 flex-wrap">
            <pre class="italic">{{ notification.description }}</pre>
          </div>
      </div>
    </td>
    <td style="width: 15%;">{{ notification.createdAt|showTime }}</td>
    <!-- <td>
      <span class="btn btn-sm btn-primary"> View </span>
    </td> -->
    <!-- {{ notification }} -->
  </tr>
</template>
  
  <script>
  import {NOTIFICATION_ICON} from '../../constants/notification'
  export default {
      props:  {
          notification: {type: Object, required: true}
      },
      computed: {
          icon(){
              return NOTIFICATION_ICON(this.notification.type)
          }
      }
  
  }
  </script>
  
  <style lang="scss" scoped>
  .description {
      h6 {
      font-size: 12px;
      font-weight: 600;
      line-height: 1.5;
    }
    pre{
      font-size: 12px;
      white-space: pre-wrap;
      word-wrap: break-word;
      font-family: 'Poppins', sans-serif !important;
    }
  }
  </style>